<rw-modal
  modalId="organizationInfoCreateModal"
  datapendoid="organization-info-create-modal"
  datatestid="organization-info-create-modal"
  [title]="pageTitle"
  [arialabel]="pageTitle"
  [dismissible]="false"
  size="lg"
  #modalRef
>
  <div modal-body>
    <form [formGroup]="frmGroup">
      <div class="row">
        <div class="col-12">
          <div
            class="p-field"
            [ngClass]="{
              'has-error': !businessName?.valid && (submitted || businessName?.touched)
            }"
          >
            <label for="businessName">Business Name</label><br />
            <input
              #businessNamelInput
              appTrimInput
              data-testid="businessName"
              id="businessName"
              name="businessName"
              [ngClass]="{ 'ui-inputtext-notallowed': orgNameDisabled }"
              formControlName="businessName"
              class="ui-inputtext form-control"
              placeholder="Business Name"
              [readonly]="orgNameDisabled"
              maxlength="64"
            />
            @if (submitted || businessName?.touched) {
              <div>
                @if (businessName.errors?.required || businessName.errors?.whitespace) {
                  <div class="help-block">Required field</div>
                }
              </div>
            }
            @if (orgNameDisabled) {
              <div>{{ canNotEditOrgNameMessage }}</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-business-address
            [isReadOnly]="readOnly"
            [address]="address"
            [parentForm]="frmGroup"
            [submitted]="submitted"
          >
          </app-business-address>
        </div>
      </div>
      <div class="row pt-1">
        <div class="col-12">
          <div
            class="p-field"
            [ngClass]="{
              'has-error': !xid?.valid && (submitted || xid?.touched)
            }"
          >
            <label for="xid">XID (optional) </label>&nbsp;<app-icon
              source="rn-help"
              placement="right"
              tt_datatestid="neworg-xid-tooltip"
              tt_datapendoid="neworg-xid-tooltip"
              tt_arialabel="New client organization xid tooltip"
              [rw-tooltip]="xidHelp"
              [escape]="false"
            ></app-icon
            ><br />
            <input
              appTrimInput
              id="xid"
              name="xid"
              formControlName="xid"
              type="text"
              placeholder="XID"
              class="form-control ui-inputtext"
            />
            @if (submitted || xid?.touched) {
              <div>
                @if (xid?.errors?.maxlength) {
                  <div class="help-block">XID is too long (must be 50 characters or less)</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      @if (canShowBusinessIndustry) {
        <div>
          <div class="row">
            <div class="col-12">
              <div
                class="p-field"
                [ngClass]="{
                  'has-error': !segment?.valid && (submitted || segment?.touched)
                }"
              >
                <span class="text_14">Business Industry</span>
                @for (seg of segments; track seg) {
                  <div>
                    <input
                      id="{{ seg }}"
                      data-testid="{{ seg }}Option"
                      type="radio"
                      formControlName="segment"
                      [value]="seg"
                    />
                    <label for="{{ seg }}">{{ seg === 'Accounting Firm' ? 'Accounting/Tax' : 'Other' }}</label>
                  </div>
                }
              </div>
            </div>
          </div>
          @if (segment.value === 'SMB' && !isLoadingIndustry) {
            <div class="row">
              <div class="col-12">
                <div
                  class="p-field"
                  [ngClass]="{
                    'has-error': !industry?.valid && (submitted || industry?.touched)
                  }"
                >
                  <span class="text_14">Business Industry</span>
                  <rw-single-select
                    [id]="'industry'"
                    [items]="industries"
                    [bindLabel]="'IndustryName'"
                    [bindValue]="'IndustryName'"
                    [placeholder]="'Select Industry'"
                    [arialabel]="'Select Industry'"
                    [datapendoid]="'selectIndustry'"
                    [datatestid]="'selectIndustry'"
                    searchable="false"
                    formControlName="industry"
                  ></rw-single-select>
                  @if (industry.value === 'Other') {
                    <div>
                      <input
                        id="otherIndustryTypeName"
                        aria-label="Other Industry"
                        class="form-control other-industry-input"
                        type="text"
                        formControlName="otherIndustryTypeName"
                        placeholder="Other Industry..."
                        maxlength="50"
                      />
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (isLoadingIndustry) {
            <div class="smallLoading">
              @if (isLoadingIndustry) {
                <app-loader text="Loading..." inline="true"></app-loader>
              }
            </div>
          }
        </div>
      }
    </form>
  </div>
  <div modal-footer>
    <app-button
      id="btnCancel"
      label="CANCEL"
      noContentPadding="true"
      buttonStyle="addUserTeritary"
      [processing]="working"
      [showProcessing]="true"
      [disabled]="working"
      (clickActionEmitter)="close()"
    >
    </app-button>
    <app-button
      id="btnSubmit"
      noContentPadding="true"
      buttonStyle="primary"
      [label]="normalButtonText"
      [disabled]="submitted || !frmGroup?.valid || this.frmGroup?.pristine"
      [showProcessing]="true"
      [processing]="working"
      (clickActionEmitter)="onSubmit()"
    >
    </app-button>
  </div>
</rw-modal>
